import { useSelector } from "react-redux";

import { Grid, Box } from "@material-ui/core";
import { makeStyles, Typography } from "@material-ui/core";

import { CarbonRevenueTotal } from "./CarbonRevenueTotal";
import { CarbonRevenueOverTime } from "./CarbonRevenueOverTime";
import { Strategies } from "./Strategies";
import { ActionTimeGroup } from "../../../../components/actionTimeTimeGroup";
import RevenuesGlance from "./RevenuesGlance";
import { COLORS } from "../../../../theme/colors";

const useStyles = makeStyles((theme) => ({
  title: {
    fontWeight: "bold",
    marginTop: theme.spacing(5),
    marginBottom: theme.spacing(2),
  },
  require: {
    color: COLORS.purple,
  },
  tabelFooter: {
    borderLeft: "1px solid rgba(0, 0, 0, 0.25)",
    borderRight: "1px solid rgba(0, 0, 0, 0.25)",
    display: "flex",
    justifyContent: "space-between",
  },
  GlanceTitle: {
    fontSize: "14px",
    lineHeight: "36px",
  },
  Glancevalue: {
    fontSize: "18px",
    color: COLORS.darks[0][100],
    fontWeight: "800",
    lineHeight: "36px",
  },
  GlanceSpan: {
    fontSize: "14px",
    lineHeight: "36px",
    fontWeight: "400",
  },
  itemContainer: {
    padding: `${theme.spacing(0)}px ${theme.spacing(3.5)}px`,
    display: "flex",
    justifyContent: "space-between",
  },
  divider: {
    height: "100%",
    background: "red",
    width: "1px",
  },
}));

export const CarbonRevenueTab = () => {
  const { period, startDate, endDate } = useSelector((state) => state.selectedPeriods);

  const classes = useStyles();

  return (
    <Box>
      <ActionTimeGroup />
      <Grid container spacing={4}>
        <Grid item xs={12} sm={4} style={{ display: "flex" }}>
          <CarbonRevenueTotal period={period} startDate={startDate} endDate={endDate} />
        </Grid>
        <Grid item xs={12} sm={8} style={{ display: "flex" }}>
          <CarbonRevenueOverTime period={period} startDate={startDate} endDate={endDate} />
        </Grid>
      </Grid>
      <Box style={{ display: "flex", justifyContent: "space-between" }}>
        <Typography className={classes.title}>
          20y Carbon Revenues Strategies <span className={classes.require}>*</span>
        </Typography>
        <Typography className={classes.title}>
          <span className={classes.require}>*</span> Powered by Nature6
        </Typography>
      </Box>
      <Grid spacing={12} style={{ marginBottom: "30px" }}>
        <Strategies />
      </Grid>
      <Typography className={classes.title}>
        Our Carbon Trading Experience at a Glance <span className={classes.require}>*</span>
      </Typography>
      <Grid style={{ marginBottom: "60px" }}>
        <RevenuesGlance />
      </Grid>
    </Box>
  );
};
